import React from 'react';


export default function DividedList({ children, dividerColor = '#d2d1e0' }) {
    if (!Array.isArray(children)) {
      return children ? children : null;
    }
  
    return (
      <div style={{display: "flex"}}>
        { children ? 
            children.map((child, i) => 
              <div key={i} style={{display: 'flex'}}>
                  <div>{child}</div>
                  { i !== children.length - 1 ? 
                    <div style={{width: "1.5px", margin: "11px 0px", backgroundColor: dividerColor}}/>  
                    : null }
              </div>)             
            : null }    
      </div>
    );
  }